<finra-mu3-header
  *ngIf="!isPostSubmission && !hasRoutingError"
  class="mu3-header"
  aria-label="header"
  role="banner"
  [userName]="userName"
  [subjectId]="subjectId"
  [isFormView]="formView"
></finra-mu3-header>

<div *ngIf="!isPostSubmission">
  <finra-page-level-nav
    [data]="navData$ | async"
    [isCollapsible]="false"
    id="app-mu3-form-navigator"
    [width]="(loading$ | async) ? '' : ''"
    (navSelected)="navigateToMenu($any($event).detail)"
    aria-label="navigation"
    role="navigation"
  >
    <div class="form-content">
      <ng-container *ngIf="loading$ | async; else form">
        <div class="center-page">
          <finra-spinner [isBackdrop]="false"></finra-spinner>
        </div>
      </ng-container>

      <ng-template #form>
        <router-outlet></router-outlet>
      </ng-template>
    </div>
  </finra-page-level-nav>

  <app-footer
    *ngIf="!(loading$ | async) && !hasRoutingError"
    (save)="onSave()"
    (validate)="onValidate()"
    (back)="onBack()"
    (next)="onNext()"
    [viewType]="viewType"
    [section]="currentNavId"
    [sectionNavData]="navrouteData"
    aria-label="footer"
    role="contentinfo"
  >
  </app-footer>

  <rampdi-completeness-check
    [data]="completenessCheck$ | async"
    (onclick)="navigateToField($event)"
    (close)="closeWidget()"
    (refresh)="onValidate()"
  >
  </rampdi-completeness-check>

  <rampdi-redline-widget
    *ngIf="viewType === 'formView'"
    [data]="redlineDiff$ | async"
    (onclick)="navigateToField($event)"
    (close)="closeWidget('redline')"
  ></rampdi-redline-widget>
</div>

<ng-container *ngIf="isPostSubmission">
  <router-outlet></router-outlet>
</ng-container>
